import { render, staticRenderFns } from "./ClientPrototypeItemList.vue?vue&type=template&id=bcbbb1f8&scoped=true"
import script from "./ClientPrototypeItemList.vue?vue&type=script&lang=js"
export * from "./ClientPrototypeItemList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcbbb1f8",
  null
  
)

export default component.exports